module.exports = __webpack_public_path__ + "img/检测项目管理.53e0c87c.jpg";